import { PRIMARY_ACTION_TOKENS } from '../../../theme/tokens/actionColors'

const DOWNLOAD_SPLIT_DIVIDER_COLOR = 'rgba(255, 255, 255, 0.85)'

export function getDownloadCtaSx({ density = 'card' } = {}) {
  const hoverBg = density === 'toolbar' ? PRIMARY_ACTION_TOKENS.hoverStrong : PRIMARY_ACTION_TOKENS.hover

  const base = {
    bgcolor: PRIMARY_ACTION_TOKENS.main,
    color: PRIMARY_ACTION_TOKENS.contrastText,
    fontWeight: 500,
    textTransform: 'uppercase',
    letterSpacing: '0.03em',
    boxShadow: PRIMARY_ACTION_TOKENS.shadow,
    transition: 'background-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease',
    '&:hover:not(.Mui-disabled)': {
      bgcolor: hoverBg,
      boxShadow: PRIMARY_ACTION_TOKENS.shadowHover,
      transform: 'translateY(-1px)'
    },
    '&:active:not(.Mui-disabled)': {
      transform: 'none'
    },
    '&:focus-visible': {
      outline: `3px solid ${PRIMARY_ACTION_TOKENS.focusRing}`,
      outlineOffset: '3px'
    },
    '&.Mui-disabled': {
      opacity: 0.55,
      color: PRIMARY_ACTION_TOKENS.contrastText
    }
  }

  if (density === 'toolbar') {
    return {
      ...base,
      minWidth: 100,
      height: 38,
      fontSize: 14,
      px: 2,
      py: 0,
      lineHeight: 1,
      borderRadius: 1
    }
  }

  return {
    ...base,
    minHeight: 42,
    py: 1.25,
    px: 1.75,
    fontSize: 13,
    borderRadius: 1.5
  }
}

export function getDownloadActionIconSize(density = 'card') {
  return density === 'toolbar' ? '1.125rem' : '1.25rem'
}

export function getDownloadActionIconSlotWidth(density = 'card') {
  return density === 'toolbar' ? 28 : 22
}

export function getDownloadActionContentSx({ width = '100%' } = {}) {
  return {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    width
  }
}

export function getDownloadActionIconSlotSx({ density = 'card', hidden = false } = {}) {
  const width = getDownloadActionIconSlotWidth(density)

  return {
    width,
    minWidth: width,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    '& svg': {
      marginLeft: 0,
      marginRight: 0
    },
    ...(hidden ? { visibility: 'hidden' } : {})
  }
}

export const DOWNLOAD_ACTION_TEXT_SX = {
  flex: 1,
  textAlign: 'center',
  whiteSpace: 'nowrap'
}

export function getDownloadSplitPrimarySx({ density = 'toolbar' } = {}) {
  return {
    ...getDownloadCtaSx({ density }),
    flex: 1,
    minWidth: 0,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0
  }
}

export function getDownloadSplitArrowSx({ density = 'toolbar' } = {}) {
  return {
    ...getDownloadCtaSx({ density }),
    minWidth: 1,
    width: 33,
    maxWidth: 31,
    px: 0,
    flexShrink: 0,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0
  }
}

export function getDownloadSplitGroupSx({ density = 'toolbar', fullWidth = false } = {}) {
  return {
    display: 'flex',
    ...(density === 'toolbar' && !fullWidth ? { minWidth: 220 } : {}),
    ...(fullWidth ? { width: '100%', alignSelf: 'stretch' } : {}),
    '& .MuiButtonGroup-grouped:not(:last-of-type)': {
      borderRight: `1px solid ${DOWNLOAD_SPLIT_DIVIDER_COLOR}`
    },
    '& .MuiButtonGroup-grouped:not(:first-of-type)': {
      borderLeftColor: DOWNLOAD_SPLIT_DIVIDER_COLOR
    }
  }
}
